module.exports = __webpack_public_path__ + "img/koubei.d5fbb40d.png";